import { lazy } from 'react';

const Dragger = lazy(() => import('./Dragger'));

export { Dragger };
